import { render, staticRenderFns } from "./updMltt.vue?vue&type=template&id=f208aae6"
import script from "./updMltt.vue?vue&type=script&lang=js"
export * from "./updMltt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports